module.exports = __webpack_public_path__ + "img/CLOCK.4958dfa1.svg";